import React, { useState } from "react";
import { ReactComponent as CameraIcon } from "../../../../assets/icons/cameraPlus.svg";

function AvatarUpload({ preview, onImageChange, onPreviewClick }) {
    const [fileInfo, setFileInfo] = useState({ name: "", valid: false, error: "" });

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const maxSize = 30 * 1024; // 7 کیلوبایت
        const validTypes = ["image/jpeg", "image/jpg"];

        if (!validTypes.includes(file.type)) {
            setFileInfo({ name: file.name, valid: false, error: "فرمت باید jpeg یا jpg باشد." });
            return;
        }

        if (file.size > maxSize) {
            setFileInfo({ name: file.name, valid: false, error: "حجم فایل باید کمتر از 30 کیلوبایت باشد." });
            return;
        }

        // همه چیز درست است
        setFileInfo({ name: file.name, valid: true, error: "" });

        // ارسال فایل به کامپوننت والد
        onImageChange(e);
    };

    return (
        <div className="flex items-center justify-between mb-10 relative">

            <div dir="rtl" className="flex-1 mr-2">
                <p className="text-gray-500 text-xs text-right mb-2">
                    لطفاً فایل تصویری خود را انتخاب کنید.<br />
                </p>
                <p className="text-gray-500 text-xs text-right">
                    حجم فایل باید کمتر از 30 کیلوبایت و فرمت آن jpeg یا jpg باشد.
                </p>
                {fileInfo.valid && (
                    <div className="flex items-center mt-2">
                        <span className="text-green-500 font-bold">✔</span>
                        <p className="text-gray-800 mr-1 truncate w-40" title={fileInfo.name}>
                            {fileInfo.name}
                        </p>
                    </div>
                )}
                {fileInfo.error && (
                    <p className="text-red-500 text-sm mt-2">{fileInfo.error}</p>
                )}
            </div>

            <div className="relative w-24 h-24 rounded-full">

                {preview ? (
                    <>
                        <img
                            src={preview}
                            alt="avatar"
                            onClick={onPreviewClick}
                            className="w-full h-full rounded-full object-cover cursor-pointer hover:scale-105 shadow-lg"
                        />

                        <label className="absolute -bottom-1 -right-2 cursor-pointer">
                            <div className="w-9 h-9 bg-zinc-400 rounded-full border border-white flex items-center justify-center shadow hover:scale-105 transition relative">
                                <CameraIcon className="w-6 h-6 text-white" />
                            </div>
                            <input
                                type="file"
                                accept="image/jpeg,image/jpg"
                                onChange={handleFileChange}
                                className="hidden"
                            />
                        </label>

                    </>
                ) : (
                    <label className="cursor-pointer w-full h-full flex items-center justify-center">
                        <div className="w-20 h-20 bg-zinc-400 rounded-full flex items-center justify-center shadow-lg hover:scale-105 transition relative">
                            <CameraIcon className="w-10 h-10 text-white" />
                        </div>
                        <input
                            type="file"
                            accept="image/jpeg,image/jpg"
                            onChange={handleFileChange}
                            className="hidden"
                        />
                    </label>
                )}

            </div>
        </div>
    );
}

export default AvatarUpload;